//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'

// prop types
export interface RichTextSectionProps {

    // section props
    section?: {
        noSeparator?: boolean
        paddingTop?: 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'small' | 'medium' | 'big' | 'none'
    }

    content?: string
    className?: string
}

export default function RichTextSection({
    section,
    content,
    className
}: RichTextSectionProps) {
    return (
        <Section
            bgColor='white'
            className={clsx('rich-text-section', className)}
            paddingTop={section?.paddingTop}
            paddingBottom={section?.paddingBottom}
            noSeparator={section?.noSeparator}
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-md-10 col-lg-8 offset-lg-1 col-xl-6 offset-xl-2'>
                        <RichText content={content} />
                    </div>
                </div>
            </div>
        </Section>
    )
}